<template>
  <div class="archives-water-gate">
    <div class="header">
      <div class="title">
        <ul>
          <li id="title-icon">
            <div></div>
            <span>年次レポート / {{ year }} 年 / 水門ログ</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="button-area">
      <span class="btn-submit" @click="excelDownload">Excelダウンロード</span>
    </div>
    <div class="section">
      <div class="container" v-if="displayDataCreated">
        <table class="stripe">
          <tr>
            <th class="no">#</th>
            <th class="gate-type">給水/排水</th>
            <th class="gate-status">状態</th>
            <th class="date">作業日時</th>
            <th class="worker">作業者</th>
            <th class="paddy">ほ場</th>
          </tr>
          <tr
            v-for="(row, index) in logList"
            :key="index"
          >
            <td style="text-align: center">{{ index + 1 }}</td>
            <td style="text-align: center">{{ getDisplayType(row.gate_type) }}</td>
            <td style="text-align: center">{{ getDisplayStatus(row.gate_status) }}</td>
            <td style="text-align: center">{{ formatDatetime(row.datetime) }}</td>
            <td>{{ row.worker }}</td>
            <td>{{ row.paddy_field_name }}</td>
          </tr>
          <tr v-if="logList.length < masterLogList.length">
            <td colspan="6" class="list-message" @click="onClickAllItem">
              <span> すべてを見る </span>
            </td>
          </tr>
          <tr v-if="masterLogList.length === 0">
            <td colspan="6" class="no-message">
              <span> 水門ログはありません </span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/mixins/loader";
import XLSX from "xlsx";

const LIST_COUNT = 10;
const WATER_GATE_TYPE = { SUPPLY: 1, OUT: 2 };
const WATER_GATE_STATUS = { CLOSED: "0", HALF: "1", FULL: "2" };

export default {
  components: {},

  mixins: [Loader],

  props: {},

  data() {
    return {
      year: null,
      displayDataCreated: false,
      logList: [],
      logInfo: null,
      masterLogList: [],
      // showCenterFrame: false,
    };
  },

  computed: {
  },

  async mounted() {
    this.$emit("hideMap");
    this.loading(async () => {
      try {
        await this.searchLogs();
        this.year = await this.getCurrentYear();
      } catch (error) {
        console.log(error);
        alert(error);
      }
    });
  },

  methods: {
    ...mapActions(["retrieveWaterGateAllLogs"]),
    ...mapGetters(["getCurrentYear"]),

    async searchLogs() {
      this.logList = [];
      try {
        const result = await this.retrieveWaterGateAllLogs();
        this.masterLogList = result.list;
        this.logList = this.logList.concat(
          this.masterLogList.slice(0, LIST_COUNT)
        );
      } catch (error) {
        console.log(error);
      }
      this.displayDataCreated = true;
    },

    excelDownload() {
      var ws_data = [
        [
          "#",
          "給水/排水",
          "状態",
          "作業日時",
          "作業者",
          "ほ場",
        ],
      ];
      for (let i = 0; i < this.masterLogList.length; i++) {
        const item = this.masterLogList[i];
        let rowValue = [];
        rowValue.push(i + 1);
        rowValue.push(this.getDisplayType(item.gate_type));
        rowValue.push(this.getDisplayStatus(item.gate_status));
        rowValue.push(this.formatDatetime(item.datetime, 'YYYY/MM/DD HH:mm'));
        rowValue.push(item.worker);
        rowValue.push(item.paddy_field_name);
        ws_data.push(rowValue);
      }

      var ws = XLSX.utils.aoa_to_sheet(ws_data);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

      var wb_out = XLSX.write(wb, { type: "binary" });

      let dt = new Date();
      var blob = new Blob([this.s2ab(wb_out)], {
        type: "application/octet-stream",
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download =
        "RiceLog_" +
        this.year +
        "_gatelog_" +
        this.formatDatetime(dt, 'YYYYMMDDHHmmss') +
        ".xlsx";
      link.click();
    },

    onClickAllItem() {
      this.logList = this.logList.concat(
        this.masterLogList.slice(LIST_COUNT)
      );
    },

    formatDatetime(src, format = "MM/DD HH:mm") {
      if (!src) {
        return "";
      }
      let dest = format;
      const date = new Date(src);
      dest = dest.replace(/YYYY/, date.getFullYear());
      dest = dest.replace(/MM/, ("0" + (date.getMonth() + 1)).slice(-2));
      dest = dest.replace(/DD/, ("0" + date.getDate()).slice(-2));
      dest = dest.replace(/HH/, ("0" + date.getHours()).slice(-2));
      dest = dest.replace(/mm/, ("0" + date.getMinutes()).slice(-2));
      dest = dest.replace(/ss/, ("0" + date.getSeconds()).slice(-2));
      return dest;
    },
    
    // stringをArrayBufferに変換する
    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xff;
      }
      return buf;
    },

    getDisplayType(gateType) {
      if (gateType === WATER_GATE_TYPE.SUPPLY) {
        return "給水";
      }
      else {
        return "排水";
      }
    },
    isWaterGateFull(status) {
      return status === WATER_GATE_STATUS.FULL;
    },
    isWaterGateHalf(status) {
      return status === WATER_GATE_STATUS.HALF;
    },
    getDisplayStatus(status) {
      if (this.isWaterGateFull(status)) {
        return "全開";
      }
      else if (this.isWaterGateHalf(status)) {
        return "半開";
      }
      else {
        return "閉門";
      }
    },
  },
};
</script>

<style lang="scss">
.archives-water-gate {
  // .header {
  //   margin: 2rem;
  // }
  .section {
    overflow: auto;
    width: 80%;
//    height: calc(100% - 130px);
    max-height: calc(100vh - 200px);
//    position: relative;
    margin-left: auto;
    margin-right: auto;

    .container {
      padding-right: 10px;
      padding-bottom: 10px;

      table {
        //    margin: 30px auto 30px;
        width: 100%;
        border: solid 1px #ddd;
        font-size: 0.9rem;
        background: #fff;
        table-layout: fixed;
        /* box-shadow: 0px 3px 10px rgba(0,0,0,0.05); */
      }
      th {
        padding: 8px;
        border-bottom: solid 1px #bbb;
        border-right: solid 1px #bbb;
        background: #ccc;
        font-weight: normal;
        &.no {
          width: 5%;
          text-align: center;
        }
        &.gate-type {
          width: 10%;
        }
        &.gate-status {
          width: 10%;
        }
        &.date {
          width: 15%;
        }
        &.worker {
          width: 20%;
        }
        &.paddy {
          width: 40%;
        }
      }

      th:nth-child(0) {
        border-right: none;
      }

      .tr-datas {
        cursor: pointer;
      }

      td {
        padding: 8px;
        border-bottom: solid 1px #ddd;
        border-right: solid 1px #ddd;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      td:nth-child(0) {
        border-right: none;
      }

      .stripe tr:nth-child(2n + 1) {
        background: #f7f7f7;
      }

      .list-message {
        text-align: center;
        cursor: pointer;

        span {
          color: var(--col3);
        }
      }
      .no-message {
        text-align: center;

        span {
          color: #555;
        }
      }
      .image-cell {
        text-align: center;
        cursor: pointer;
      }

    }
  }

  .button-area {
    height: calc(100% - 130px);
    position: relative;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 40px;
    margin-bottom: 20px;

    .btn-submit {
      display: inline-block;
      background: var(--purple);
      font-size: 14px;
      text-align: center;
      width: 200px;
      height: 30px;
      border-radius: 15px;
      color: #fff;
      padding: 6px 10px;
      margin: 1px 6px;
      cursor: pointer;
      &.disable {
        opacity: 0.5;
        cursor: inherit;
      }
    }
  }
  .ic-images {
    background: url("~@/assets/icons/ic_photo_active.svg") no-repeat center
      center;
    height: 20px;
    width: 20px;
    display: block;
    margin: auto;
  }

  /* タイトル */
  .header .title {
    width: 100%;
    // margin: 20px 0 0 0;
    box-sizing: border-box;
    // border-bottom: solid 2px var(--purple-secondary);
  }
  .header .title ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style-type: none;
    box-sizing: border-box;
    user-select: none;
  }
  .header .title li {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 60px; /* 各メニューの高さ */
    // cursor: pointer;
    background: none;
    z-index: 10;
    display: flex;
    align-items: center;
    color: var(--purple);
  }
  .header .title li span {
    font-size: 1.1rem;
    // padding: 0px 0px 0px 10px;
    transition: padding 0.8s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    color: var(--purple);
  }
  .header .title li > div {
    width: 50px;
    height: 100%;
  }

  .center-frame-container {
    position: absolute;
    //   display: none;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.5);
    z-index: 90;

    .center-frame {
      margin: 0;
      padding: 15px 30px;
      width: 80%;
      max-width: 800px;
      //   height: 80vh;
      max-height: 80vh;
      overflow-y: scroll;
      // position: absolute;
      position: fixed;
      top: 10vh;
      background: white;
      border-radius: 20px;
      box-shadow: 0 0 30px 15px rgba(0, 0, 0, 0.3);
      // animation: scaleAnimIn 0.5s;
    }

    .title-area {
      width: 100%;
      // height: 80px;
      min-height: 80px;
      padding: 0;
      box-sizing: border-box;
      display: grid;
      grid-template-columns: 1fr 32px;
      align-items: center;
      border-bottom: solid 1px #ddd;

      .mobile & {
        height: 60px;
      }
    }

    .title-area h3 {
      margin: 0;
      padding: 0 0 0 10px;
      display: flex;
      align-items: center;
    }

    .title-area h3 span {
      width: 25px;
      height: 45px;
      display: inline-block;
      margin: 0 10px 0 0;
    }

    .btn-close {
      cursor: pointer;
      width: 32px;
      height: 32px;
      background: url("~@/assets/icons/ic_cancel.svg") no-repeat center center;
      background-size: contain;
    }
    .center-frame-section {
      overflow: auto;
      width: 100%;
      height: calc(100% - 130px);
      position: relative;

      .container {
        margin: 0;

        .contents-body {
          margin: 10px;

          &.scroll {
            max-height: 50vh;
            overflow-y: scroll;
          }

          span.textarea {
            white-space: pre-line;
          }

          dl.columns {
            width: 100%;
            display: grid;
            grid-template-columns: 180px 1fr;
            align-items: top;
            grid-gap: 0px 0px;
            margin: 0;
            padding: 0;
            font-size: 16px;
            color: #333;

            .mobile & {
              grid-template-columns: 1fr 1.5fr;
            }
          }

          .columns dt {
            display: block;
            text-align: right;
            width: 100%;
            margin: 0;
            padding: 16px;
          }

          .columns dd {
            display: block;
            width: 100%;
            border-left: solid 1px #ddd;
            margin: 0;
            padding: 16px;
          }
        }

        .contents-footer {
          margin: 10px;
        }
      }
    }
  }
  .image-area-view {
    width: 100%;

    img {
      max-width: 100%;
      margin: 10px 0px;
    }
  }
  .detail-list-container {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    margin: 10px auto 10px;

    table {
      width: 100%;
      font-size: 0.9rem;
      background: #fff;
    }
    th {
      padding: 8px;
      border-bottom: solid 1px #bbb;
      background: #ccc;
      font-weight: normal;
    }

    th:nth-child(0) {
      border-right: none;
    }

    td {
      padding: 8px;
      border-bottom: solid 1px #ddd;

      &.tx-no {
        width: 10%;
        text-align: center;
      }

      &.tx-name {
        max-width: 0%;
      }
    }

    td:nth-child(0) {
      border-right: none;
    }

    .stripe tr:nth-child(2n + 1) {
      background: #f7f7f7;
    }
  }
  .detail-item-list-container {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    margin: 10px auto 10px;
  }

  /* アイコンの指定 */
  #title-icon > div {
    background: url("~@/assets/icons/ic_folder.svg") no-repeat center center;
  }
}
</style>
